import * as types from './types'
import moment from 'moment'
import globals from '@/plugins/globals'

export default {
  [types.SET_DATE](state, data) {
    if (data.name === 'start') {
      state.startDate = data.value
    } else {
      state.endDate = data.value
    }
  },
  [types.SET_VIEW](state, data) {
    switch (data.name) {
      case 'analyze':
        state.analyzeView = parseInt(data.value)
        break
      case 'range':
        state.rangeView = parseInt(data.value)
        break
      case 'firm':
        state.invoiceFirm = parseInt(data.value)
        break
      default:
        break
    }
  },
  [types.SET_TECHDATA](state, data) {
    state.techData = data
  },
  [types.SET_TIMEZONE](state, tz) {
    state.tz = tz
  },
  [types.SET_DATA](state, data) {
    let foundTech = null
    switch (data.name) {
      case 'commission':
        foundTech = state.payroll.find(x => parseInt(x.contact) === parseInt(data.contact))
        if (foundTech) {
          let foundRequest = foundTech.assignments.find(x => parseInt(x.calibrateEvent) === parseInt(data.calibrateEvent))
          if (foundRequest) {
            foundRequest.isChanged = true
            foundRequest.commissionOverride = parseFloat(data.amount)
            foundRequest.commission = parseFloat(data.amount)
            let total = 0
            foundTech.assignments.forEach(assignment => {
              total += parseFloat(assignment.commission)
            })
            foundTech.commission = total
            // force refresh
            foundRequest.services = [...foundRequest.services]
          }
        }
        break
      case 'original':
        foundTech = state.payroll.find(x => parseInt(x.contact) === parseInt(data.contact))
        if (foundTech) {
          let foundRequest = foundTech.assignments.find(x => parseInt(x.calibrateEvent) === parseInt(data.calibrateEvent))
          if (foundRequest) {
            foundRequest.originalCommission = parseFloat(data.amount)
            // force refresh
            foundRequest.services = [...foundRequest.services]
          }
        }
        break
    }
  },
  [types.SET_HISTORY](state, data) {
    state.calibrateHistory = data
    console.log('Got Calibrate History', data)
  },
  [types.SET_DASHBOARD](state, data) {
    state.dashboard = data
  },
  [types.SET_DASHBOARD_BREAKOUT](state, data) {
    state.dashboardBreakout = data
  },
  [types.SET_DASHBOARD_TOP3](state, data) {
    state.dashboardTop3 = data
  },
  [types.SET_DASHBOARD_TOP](state, data) {
    state.dashboardTop = data
  },
  [types.SET_DASHBOARD_PROFIT](state, data) {
    state.dashboardProfit = data
  },
  [types.SET_DASHBOARD_CYCLETIMES](state, data) {
    state.dashboardCycleTimes = data
  },
  [types.SET_DASHBOARD_TREND](state, data) {
    state.dashboardTrend = data
  },
  [types.SET_OPPORTUNITIES](state, data) {
    state.dashboardOpportunities = data
  },
  [types.SET_PAYMENTS](state, data) {
    state.payments = []
    if (data) {
      if (data !== '') {
        state.payments = data
      }
    }
    console.log('Got Payments - before Total', state.payments)
    if (state.payments.length > 0) {
      state.payments.forEach(payment => {
        payment.total = 0
        if (payment.services) {
          payment.services.forEach(element => {
            if (element) {
              payment.total += parseFloat(element.rate)
              // if (element.rate) {
              //   element.rate = element.rate.toFixed(2)
              // }
            }
          })
          payment.total = payment.total.toFixed(2)
        }
      })
    }
    console.log('Got Payments - after Total', state.payments)
  },
  [types.SET_PAYROLL](state, data) {
    state.payroll = []
    if (data) {
      if (data !== '') {
        state.payroll = data
      }
    }
    if (state.payroll.length > 0) {
      state.payroll.forEach(tech => {
        tech.hours = 0
        tech.commission = 0
        tech.sales = 0
        if (tech.assignments !== null) {
          tech.assignments.forEach(assignment => {
            assignment.isChanged = false
            assignment.hours = 0
            assignment.sales = 0
            assignment.commission = 0
            assignment.originalCommission = null
            if (assignment.started !== null && assignment.completed !== null) {
              let duration = moment.duration(moment(assignment.completed).diff(moment(assignment.started)))
              assignment.hours = duration.asHours()
            }
            if (assignment.services) {
              assignment.services.forEach(service => {
                service.commissionRate = 0
                service.amount = 0
                if (service.rate) {
                  service.rate = parseFloat(service.rate).toFixed(2)
                } else {
                  service.rate = 0
                }
                if (tech.commissionRates) {
                  let found = tech.commissionRates.find(x => parseInt(x.calibrateServiceGroup) === parseInt(service.calibrateServiceGroup))
                  if (found) {
                    if (found.commission != null) {
                      service.commissionRate = (parseFloat(found.commission) / 100).toFixed(1)
                      service.amount = ((parseFloat(found.commission) / 100) * parseFloat(service.rate)).toFixed(2)
                    }
                  }
                }
                assignment.sales += parseFloat(service.rate)
                tech.sales += parseFloat(service.rate)
                assignment.commission += parseFloat(service.amount)
              })
              if (assignment.commissionOverride !== null) {
                assignment.commission = assignment.commissionOverride
                assignment.originalCommission = assignment.commissionOverride
              }
            }
            tech.hours += parseFloat(assignment.hours)
            tech.commission += parseFloat(assignment.commission)
          })
        }
      })
    }
    console.log('Got Payroll Data', state.payroll)
  },
  [types.RESET_LOG](state) {
    state.log = []
  },
  [types.SET_PARAMETER](state, data) {},
  [types.FILTER_LOG](state, data) {
    switch (data.action) {
      case 'filter':
        if (data.value !== '') {
          state.log = state.original.filter(x => x.level.toUpperCase() === data.value.toUpperCase())
        } else {
          state.log = JSON.parse(JSON.stringify(state.original))
        }
        break
      case 'search':
        if (data.value !== '') {
          state.log = state.original.filter(x => x.message.indexOf(data.value) >= 0 || x.machineName.indexOf(data.value) >= 0)
        } else {
          state.log = JSON.parse(JSON.stringify(state.original))
        }
        break
      case 'sort':
        if (data.value.search !== '') {
          state.log = state.original.filter(x => x.message.indexOf(data.value.search) >= 0 || x.machineName.indexOf(data.value.search) >= 0)
        } else if (data.value.filter !== '') {
          state.log = state.original.filter(x => x.level.toUpperCase() === data.value.filter.toUpperCase())
        } else {
          state.log = JSON.parse(JSON.stringify(state.original))
        }
        break
      default:
        break
    }
    if (data.action === 'sort') {
      let sortBy = 'datetime'
      let sortDir = 'asc'
      if (data.value.column.field !== '') {
        sortBy = data.value.column.field
      }
      if (data.value.sortDir !== '') {
        sortDir = data.value.sortDir
      }
      state.log = globals.sortArray(state.log, sortBy, sortDir)
    }
    console.log('Filtering', {
      data: data,
      original: state.original,
      log: state.log
    })
  },
  [types.SET_LOG](state, data) {
    state.log = []
    state.original = []
    let temp = []
    if (data) {
      if (data.length > 0) {
        data.forEach(element => {
          if (element.values) {
            if (element.values.indexOf(';') > 0) {
              let record = element.values.split(';')
              let title = record[3].replace('Message=', '')
              title = title.substring(0, title.indexOf(':'))
              if (record.length > 8) {
                temp.push({
                  timestamp: record[0].replace('LogTimeStamp=', ''),
                  level: record[1].replace('Level=', ''),
                  name: record[2].replace('LoggerName=', ''),
                  message: record[3].replace('Message=', ''),
                  title: title,
                  exception: record[4].replace('Exception=', ''),
                  innerException: record[5].replace('InnerException=', ''),
                  messageLayout: record[6].replace('MessageWithLayout=', ''),
                  machineName: record[7].replace('MachineName=', ''),
                  datetime: new Date(element.timestamp)
                })
              } else if (record.length > 7) {
                temp.push({
                  timestamp: record[0].replace('LogTimeStamp=', ''),
                  level: record[1].replace('Level=', ''),
                  name: record[2].replace('LoggerName=', ''),
                  message: record[3].replace('Message=', ''),
                  title: title,
                  exception: record[4].replace('Exception=', ''),
                  innerException: '',
                  messageLayout: record[5].replace('MessageWithLayout=', ''),
                  machineName: record[6].replace('MachineName=', ''),
                  datetime: new Date(element.timestamp)
                })
              } else {
                temp.push({
                  timestamp: record[0].replace('LogTimeStamp=', ''),
                  level: record[1].replace('Level=', ''),
                  name: record[2].replace('LoggerName=', ''),
                  message: record[3].replace('Message=', ''),
                  title: title,
                  exception: '',
                  innerException: '',
                  messageLayout: record[4].replace('MessageWithLayout=', ''),
                  machineName: record[5].replace('MachineName=', ''),
                  datetime: new Date(element.timestamp)
                })
              }
            }
          }
        })
        if (temp.length > 0) {
          state.log = globals.sortArray(temp, 'datetime')
          state.original = JSON.parse(JSON.stringify(state.log))
        }
      }
    }
    console.log('Got the Log', state.log)
  },
  [types.SET_FRAGMENTATION](state, data) {
    state.fragmentation = data
  },
  [types.SET_MISSING_INDEXES](state, data) {
    state.missingIndexes = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/mutations.js